export default __webpack_public_path__ + "images/csv-16.png";